import { RouteProps } from '../../routes/AppRouter'
import { BedfilesKits } from '../../features/bedfilesKit'
import { Title } from '../../components/common/Title'

export const Kits = (props: RouteProps) => {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <BedfilesKits />
    </>
  )
}
